import { render, staticRenderFns } from "./UserMasterRegist.vue?vue&type=template&id=398c604f"
import script from "./UserMasterRegist.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMasterRegist.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports